export default __webpack_public_path__ + "static/media/aiSprite-a2ebf40dc6c3332bab56af8e525fc010.png";